import { useState, useEffect } from "react";
import Api from "../../../components/api/Api";
import { showToast } from "../../../../components/common/notification/Notification";

export default function useSubscriptionPlans() {
  const subscriptionPlans = Api({ url: "api/subscription/plan/list" });

  const [plans, setPlans] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [expandedPlan, setExpandedPlan] = useState(null);
  const [loading, setLoading] = useState(false);

const fetchPlans = async () => {
  try {
    const { data } = await subscriptionPlans.fetchData();
    console.log(data);
    if (data.statusType === "SUCCESS") {
      const updatedPlans = data.subscriptionPlans.map((plan) => {
        const isFree =
          plan.is_free_plan ||
          plan.freePLan ||
          plan.price_paise === 0;

        // Convert paise → rupees
        const basePrice = plan.price_paise / 100;

        let totalAmount = basePrice;

        const registrationFee = isFree ? 0 : 200;
        totalAmount += registrationFee;

        return {
          ...plan,
          duration_in_days: plan.duration_days,
          price: basePrice,
          registration_fee: registrationFee,
          total_price: totalAmount,
          is_free: isFree,
        };
      });

      setPlans(updatedPlans);

      const firstPaidPlan = updatedPlans.find((p) => !p.is_free);
      setSelectedPlan(firstPaidPlan?.id || updatedPlans[0]?.id);
    }
  } catch (err) {
    showToast("Unable to fetch subscription plans", { type: "error" });
  }
};


  useEffect(() => {
    fetchPlans();
  }, []);

  return {
    plans,
    selectedPlan,
    setSelectedPlan,
    expandedPlan,
    setExpandedPlan,
    loading
  };
}
